"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _AdditionalProperties = _interopRequireDefault(require("./AdditionalProperties"));
var _EdelmetallProduktKonditionen = _interopRequireDefault(require("./EdelmetallProduktKonditionen"));
var _HeaderDaten = _interopRequireDefault(require("./HeaderDaten"));
var _HeaderResponse = _interopRequireDefault(require("./HeaderResponse"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * Rage+ API
 * API für das Rage+ / VerseNeo Backend der BLB Shops für Edelmetalle und Sorten
 *
 * The version of the OpenAPI document: 1.0.44
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The EdelmetallKonditionen model module.
 * @module model/EdelmetallKonditionen
 * @version 1.0.44
 */
var EdelmetallKonditionen = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>EdelmetallKonditionen</code>.
   * Konditionen speziefisch für Edelmetalle
   * @alias module:model/EdelmetallKonditionen
   * @implements module:model/HeaderResponse
   * @param header {module:model/HeaderDaten} 
   * @param defaultEmBpBuyKondition {Number} Default für Edelmetall Verkaufen Kondition
   * @param defaultEmWlBuyKondition {Number} Default für Edelmetall Kaufen Kondition
   * @param edelmetallProduktKonditionen {module:model/EdelmetallProduktKonditionen} 
   * @param defaultEmBpBuyBetrag {Number} Fixer Betrag
   * @param defaultEmWlBuyBetrag {Number} Fixer Betrag
   */
  function EdelmetallKonditionen(header, defaultEmBpBuyKondition, defaultEmWlBuyKondition, edelmetallProduktKonditionen, defaultEmBpBuyBetrag, defaultEmWlBuyBetrag) {
    _classCallCheck(this, EdelmetallKonditionen);
    _HeaderResponse.default.initialize(this, header);
    EdelmetallKonditionen.initialize(this, header, defaultEmBpBuyKondition, defaultEmWlBuyKondition, edelmetallProduktKonditionen, defaultEmBpBuyBetrag, defaultEmWlBuyBetrag);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(EdelmetallKonditionen, null, [{
    key: "initialize",
    value: function initialize(obj, header, defaultEmBpBuyKondition, defaultEmWlBuyKondition, edelmetallProduktKonditionen, defaultEmBpBuyBetrag, defaultEmWlBuyBetrag) {
      obj['header'] = header;
      obj['defaultEmBpBuyKondition'] = defaultEmBpBuyKondition;
      obj['defaultEmWlBuyKondition'] = defaultEmWlBuyKondition;
      obj['edelmetallProduktKonditionen'] = edelmetallProduktKonditionen;
      obj['defaultEmBpBuyBetrag'] = defaultEmBpBuyBetrag;
      obj['defaultEmWlBuyBetrag'] = defaultEmWlBuyBetrag;
    }

    /**
     * Constructs a <code>EdelmetallKonditionen</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/EdelmetallKonditionen} obj Optional instance to populate.
     * @return {module:model/EdelmetallKonditionen} The populated <code>EdelmetallKonditionen</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new EdelmetallKonditionen();
        _HeaderResponse.default.constructFromObject(data, obj);
        if (data.hasOwnProperty('header')) {
          obj['header'] = _HeaderDaten.default.constructFromObject(data['header']);
        }
        if (data.hasOwnProperty('id')) {
          obj['id'] = _ApiClient.default.convertToType(data['id'], 'String');
        }
        if (data.hasOwnProperty('hashCode')) {
          obj['hashCode'] = _ApiClient.default.convertToType(data['hashCode'], 'Date');
        }
        if (data.hasOwnProperty('defaultEmBpBuyKondition')) {
          obj['defaultEmBpBuyKondition'] = _ApiClient.default.convertToType(data['defaultEmBpBuyKondition'], 'Number');
        }
        if (data.hasOwnProperty('defaultEmBpSellKondition')) {
          obj['defaultEmBpSellKondition'] = _ApiClient.default.convertToType(data['defaultEmBpSellKondition'], 'Number');
        }
        if (data.hasOwnProperty('defaultEmWlBuyKondition')) {
          obj['defaultEmWlBuyKondition'] = _ApiClient.default.convertToType(data['defaultEmWlBuyKondition'], 'Number');
        }
        if (data.hasOwnProperty('edelmetallProduktKonditionen')) {
          obj['edelmetallProduktKonditionen'] = _EdelmetallProduktKonditionen.default.constructFromObject(data['edelmetallProduktKonditionen']);
        }
        if (data.hasOwnProperty('defaultEmBpBuyBetrag')) {
          obj['defaultEmBpBuyBetrag'] = _ApiClient.default.convertToType(data['defaultEmBpBuyBetrag'], 'Number');
        }
        if (data.hasOwnProperty('defaultEmWlBuyBetrag')) {
          obj['defaultEmWlBuyBetrag'] = _ApiClient.default.convertToType(data['defaultEmWlBuyBetrag'], 'Number');
        }
        if (data.hasOwnProperty('additionalProperties')) {
          obj['additionalProperties'] = _AdditionalProperties.default.constructFromObject(data['additionalProperties']);
        }
        if (data.hasOwnProperty('defaultEmMaBuyKondition')) {
          obj['defaultEmMaBuyKondition'] = _ApiClient.default.convertToType(data['defaultEmMaBuyKondition'], 'Number');
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>EdelmetallKonditionen</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>EdelmetallKonditionen</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // check to make sure all required properties are present in the JSON string
      var _iterator = _createForOfIteratorHelper(EdelmetallKonditionen.RequiredProperties),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var property = _step.value;
          if (!data[property]) {
            throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
          }
        }
        // validate the optional field `header`
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (data['header']) {
        // data not null
        _HeaderDaten.default.validateJSON(data['header']);
      }
      // ensure the json data is a string
      if (data['id'] && !(typeof data['id'] === 'string' || data['id'] instanceof String)) {
        throw new Error("Expected the field `id` to be a primitive type in the JSON string but got " + data['id']);
      }
      // validate the optional field `edelmetallProduktKonditionen`
      if (data['edelmetallProduktKonditionen']) {
        // data not null
        _EdelmetallProduktKonditionen.default.validateJSON(data['edelmetallProduktKonditionen']);
      }
      // validate the optional field `additionalProperties`
      if (data['additionalProperties']) {
        // data not null
        _AdditionalProperties.default.validateJSON(data['additionalProperties']);
      }
      return true;
    }
  }]);
}();
EdelmetallKonditionen.RequiredProperties = ["header", "defaultEmBpBuyKondition", "defaultEmWlBuyKondition", "edelmetallProduktKonditionen", "defaultEmBpBuyBetrag", "defaultEmWlBuyBetrag"];

/**
 * @member {module:model/HeaderDaten} header
 */
EdelmetallKonditionen.prototype['header'] = undefined;

/**
 * ID der Kondition
 * @member {String} id
 */
EdelmetallKonditionen.prototype['id'] = undefined;

/**
 * HashCode der Konditionen
 * @member {Date} hashCode
 */
EdelmetallKonditionen.prototype['hashCode'] = undefined;

/**
 * Default für Edelmetall Verkaufen Kondition
 * @member {Number} defaultEmBpBuyKondition
 */
EdelmetallKonditionen.prototype['defaultEmBpBuyKondition'] = undefined;

/**
 * Default für Edelmetall Ankauf Kondition
 * @member {Number} defaultEmBpSellKondition
 */
EdelmetallKonditionen.prototype['defaultEmBpSellKondition'] = undefined;

/**
 * Default für Edelmetall Kaufen Kondition
 * @member {Number} defaultEmWlBuyKondition
 */
EdelmetallKonditionen.prototype['defaultEmWlBuyKondition'] = undefined;

/**
 * @member {module:model/EdelmetallProduktKonditionen} edelmetallProduktKonditionen
 */
EdelmetallKonditionen.prototype['edelmetallProduktKonditionen'] = undefined;

/**
 * Fixer Betrag
 * @member {Number} defaultEmBpBuyBetrag
 */
EdelmetallKonditionen.prototype['defaultEmBpBuyBetrag'] = undefined;

/**
 * Fixer Betrag
 * @member {Number} defaultEmWlBuyBetrag
 */
EdelmetallKonditionen.prototype['defaultEmWlBuyBetrag'] = undefined;

/**
 * @member {module:model/AdditionalProperties} additionalProperties
 */
EdelmetallKonditionen.prototype['additionalProperties'] = undefined;

/**
 * Default Mitarbeiterkondition für Edelmetall Verkauf
 * @member {Number} defaultEmMaBuyKondition
 */
EdelmetallKonditionen.prototype['defaultEmMaBuyKondition'] = undefined;

// Implement HeaderResponse interface:
/**
 * @member {module:model/HeaderDaten} header
 */
_HeaderResponse.default.prototype['header'] = undefined;
var _default = exports.default = EdelmetallKonditionen;